import { Material } from "@phdsoft/three";
import { MaterialSubType } from "./MaterialSubType";
import { ResourceElement } from "./ResourceElement";

export interface CoatingEfficientyFactor {
    InitialFactor?: number;
    MeanFactor?: number;
    FinalFactor?: number;
}
export class MaterialType extends ResourceElement implements CoatingEfficientyFactor {
    InitialFactor?: number;
    MeanFactor?: number;
    FinalFactor?: number;


    // private _Density: number;
    // public get Density(): number {
    //     return this._Density;
    // }
    // public set Density(v: number) {
    //     this._Density = v;
    // }

    // private _ModulusOfElasticity: number;
    // public get ModulusOfElasticity(): number {
    //     return this._ModulusOfElasticity;
    // }
    // public set ModulusOfElasticity(v: number) {
    //     this._ModulusOfElasticity = v;
    // }

    // private _ShearModulus: number;
    // public get ShearModulus(): number {
    //     return this._ShearModulus;
    // }
    // public set ShearModulus(v: number) {
    //     this._ShearModulus = v;
    // }

    // private _YieldStrength: number;
    // public get YieldStrength(): number {
    //     return this._YieldStrength;
    // }
    // public set YieldStrength(v: number) {
    //     this._YieldStrength = v;
    // }

    // private _UltimateStrength: number;
    // public get UltimateStrength(): number {
    //     return this._UltimateStrength;
    // }
    // public set UltimateStrength(v: number) {
    //     this._UltimateStrength = v;
    // }

    // private _BreakingStrength: number;
    // public get BreakingStrength(): number {
    //     return this._BreakingStrength;
    // }
    // public set BreakingStrength(v: number) {
    //     this._BreakingStrength = v;
    // }

    private _CoatingEficiency: number;
    public get CoatingEficiency(): number {
        return this._CoatingEficiency;
    }
    public set CoatingEficiency(v: number) {
        this._CoatingEficiency = v;
    }


    private _materialSubType: MaterialSubType;
    public get materialSubType(): MaterialSubType {
        return this._materialSubType;
    }
    public set materialSubType(v: MaterialSubType) {
        this._materialSubType = v;
    }

    constructor(material: any) {
        super();

        this.Guid = material.Guid;
        this.Name = material.Name;
        this.materialSubType = new MaterialSubType(material);
    }



    private MaterialSubTypes: Array<MaterialSubType>;

    public GetMaterialSubType(id: string): MaterialSubType {
        return this.MaterialSubTypes.find(x => x.Guid === id);
    }

    public GetMaterialSubTypeByName(name: string): MaterialSubType {
        return this.MaterialSubTypes.find(x => x.Name === name);
    }


}